export default __webpack_public_path__ + "static/media/settings-white.7aabc274.svg";